import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import { createContext, useContextSelector } from 'use-context-selector';

export const DrawerContext = createContext(null);

export const useDrawerContext = (s = null) => useContextSelector(DrawerContext, s);

export const DrawerProvider = memo(({children, value}) => (    
    <DrawerContext.Provider value={value}>
        {children}
    </DrawerContext.Provider>
), isEqual);